import axios from 'axios'
import router from '../../router/index.js'
import { BASE_API_URL } from '../api.js'

// const tokenKey = 'jwt-token'
const tokenKey = 'vlab-jwt-token'

const state = {
  googleClientId: {
    client_id: '199548499178-45aoehsbfq2bdmqa22r0fcojup2r06h3.apps.googleusercontent.com'
  },
  access: localStorage.getItem(tokenKey) || null,
  social: {
    register: null,
    email: null
  },
  user: null,
  email: { // When user find own password, email have to be validate to send password change url
    valid: null,
    msg: ''
  },
  register: {
    check: null,
    msg: null
  },
  passToken: null
}
const instance = axios.create({
  // baseURL: BASE_API_URL
  baseURL: 'https://vlab.pusan.ac.kr/backend'
})
const getters = {
  isAuth: state => {
    return !!state.access
  },
  getSocialInfo: state => {
    return state.social
  },
  getGoogleClientId: state => {
    return state.googleClientId
  },
  getUser: state => {
    return state.user
  },
  getValid: state => {
    return state.email
  },
  getRegistered: state => {
    return state.register
  }
}

const mutations = {
  createToken (state, { access }) {
    localStorage.setItem(tokenKey, access)
    state.access = access
    instance.defaults.headers.common.Authorization = `${access}`
  },
  deleteToken (state) {
    localStorage.removeItem(tokenKey)
    state.access = null
    state.passToken = null
    delete instance.defaults.headers.common.Authorization
  },
  updateSocialInfo (state, obj) {
    state.social = obj
  },
  updateUserInfo (state, obj) {
    state.user = obj
  },
  updateEmailValid (state, obj) {
    state.email = obj
  },
  checkRegister (state, payload) {
    state.register.check = payload.registration
    state.register.msg = payload.msg
    // console.log(state.register);
  },
  createPasswordToken (state, payload) {
    const _url = payload.url
    const access = _url.substring(_url.indexOf('=') + 1, _url.length)
    state.passToken = access
  }
}

const actions = {
  isRegistered ({
    commit
  }) {
    commit('checkRegister', { registration: null, msg: null })
    instance.post('/users/user-check/')
      .then(res => {
        if (res.data.registered === true) {
          localStorage.removeItem('socialState')
          commit('updateSocialInfo', {
            register: true,
            email: res.data.user.email
          })
          commit('updateUserInfo', res.data.user)
          router.push({
            name: 'Home'
          })
        } else {
          commit('updateSocialInfo', {
            register: false,
            email: res.data.user.email
          })
          localStorage.setItem('socialState', 'waiting')
        }
      }).catch(err => {
        console.error('isRegister', err)
      })
  },
  googleSignin ({
    commit,
    dispatch
  }, resp) {
    const keys = Object.keys(resp)
    const token = resp[keys['1']].access_token

    instance.post('/users/google/', {
      access_token: token
    }).then(res => {
      const access = res.data.token
      commit('createToken', {
        access
      })
      dispatch('isRegistered', {
        access
      })
    }).catch(err => {
      console.error(err)
    }).finally(() => {
      // console.groupEnd()
    })
  },

  signin ({ commit, dispatch }, user) {
    commit('checkRegister', { registration: null, msg: null })
    return new Promise((resolve, reject) => {
      instance.post(`/users/login/`, { email: user.email, password: user.password })
        .then(response => {
          commit('createToken', {
            access: response.data.token
          })
          dispatch('settingUser')
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  googleSignup ({ commit }, payload) {
    commit('checkRegister', { registration: null, msg: null })
    instance.post('/users/social-signup/', {
      name: payload.student_name,
      organization: payload.organization,
      major: payload.major,
      student_num: payload.student_num
    })
      .then(res => {
        commit('deleteToken')
        commit('checkRegister', { registration: true, msg: 'V-Lab 가입을 환영합니다. 로그인해주세요.' })
      }).catch(err => {
        console.error('googleSignup', err)
      })
  },

  signup ({ commit }, payload) {
    commit('checkRegister', { registration: 'waiting', msg: null })
    instance.post('/users/registration/', {
      email: payload.email,
      password1: payload.password1,
      password2: payload.password2,
      student_name: payload.student_name,
      organization: payload.organization,
      major: payload.major,
      student_num: payload.student_num
    })
      .then(res => {
        // console.log(res);
        let msg = ''
        if (res.data.registration === false) {
          msg = '이미 가입된 이메일입니다. 다시 입력해주세요.'
        } else {
          msg = 'V-Lab 가입을 환영합니다. 로그인해주세요.'
        }
        commit('checkRegister', { registration: res.data.registration, msg })
      })
      .catch(err => {
        console.error('signup', err)
      })
  },
  signout ({ commit }) {
    commit('deleteToken')
    commit('updateSocialInfo', {
      register: null,
      email: null
    })
    router.go()
  },
  settingUser (context) {
    instance.defaults.headers.common.Authorization = context.state.access
    instance.post('/users/user-check/', {})
      .then(res => {
        context.commit('updateUserInfo', res.data.user)
      })
      .catch(err => {
        console.error('settingUser', err)
      })
  },
  validateEmail ({
    commit
  }, payload) {
    commit('updateEmailValid', {
      valid: 'waiting',
      msg: '인증 중입니다. 기다려주세요.'
    })
    instance.post('/users/reset/', {
      email: payload.email
    }).then(res => {
      if (res.data.valid === true) {
        commit('updateEmailValid', {
          valid: true,
          msg: '인증되었습니다. 해당 이메일로 비밀번호 초기화 주소를 보냈습니다.'
        })
      } else {
        commit('updateEmailValid', {
          valid: false,
          msg: '해당 이메일이 존재하지 않습니다.'
        })
      }
    }).catch(err => {
      console.error('validateEmail', err)
    })
  },
  validatePasswordToken (context, payload) {
    if (context.state.access == null) context.commit('createToken', { access: context.state.passToken })
    instance.post('/users/reset-done/', {
      password1: payload.password
    }).then(res => {
      if (!payload.logined) { // from sign page (not logined)
        context.commit('deleteToken')
        router.push({
          name: 'sign'
        })
      } else { // from main page(logined)
        router.push({
          name: 'dash'
        })
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
